module.exports = __webpack_public_path__ + "img/Time_management_w_1.fb9b3ae1.svg";